import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation, useNavigationType } from 'react-router-dom';
import MobileBlock from './components/MobileBlock';
import UpdateNoticePopup from './components/UpdateNoticePopup'; // v2 전환 예고 팝업 (10/10 배포 시 제거)
import { useVersionCheck } from './utils/versionCheck';

import ContactPage from './pages/ContactPage'; // 문의하기 페이지(로그인 전)
import LandingPage from './pages/LandingPage'; // 메인 페이지(로그인 전)
import MarketerLandingPage from './pages/MarketerLandingPage'; // 광고주 전용 랜딩(LP)
import InfluencerLandingPage from './pages/InfluencerLandingPage'; // 인플루언서 전용 랜딩(LP)
import ServiceGuide from './pages/ServiceGuide'; // 서비스 가이드 페이지
import NoticeCreate from './pages/adminpages/NoticeCreate'; // 어드민 공지 만들기 페이지
import AdminLogin from './pages/adminpages/AdminLogin'; // 어드민 로그인 페이지
import AdminMain from './pages/adminpages/AdminMain'; // 어드민 메인 페이지
import AdvertiserPage from './pages/adminpages/AdvertiserPage'; // 어드민 광고주 관리 페이지
import AdvertiserInquiryCheckPage from './pages/adminpages/AdvertiserInquiryCheckPage'; // 어드민 광고주 문의하기 관리 페이지
import InfluencerPage from './pages/adminpages/InfluencerPage'; // 어드민 인플루언서 관리 페이지
import InfluencerRegisterCheckPage from './pages/adminpages/InfluencerRegisterCheckPage'; // 어드민 인플루언서 가입승인 페이지
import PointPage from './pages/adminpages/PointPage'; // 어드민 포인트 관리 페이지
import ProjectPage from './pages/adminpages/ProjectPage'; // 어드민 프로젝트 관리 페이지
import MoneyPage from './pages/adminpages/MoneyPage'; // 어드민 매출 관리 페이지
import AdvertiserRefundPage from './pages/adminpages/AdvertiserRefundPage';  // 환불 관리 페이지
import InfluencerExchangePage from './pages/adminpages/InfluencerExchangePage';  // 환전 관리 페이지
import InfluencerInfoPage from './pages/adminpages/InfluencerInfoPage';  // 인플루언서 정보관리 페이지
import AdvertiserInfoPage from './pages/adminpages/AdvertiserInfoPage';      // 정보 관리 페이지
import InfluencerRegisterPage from './pages/InfluencerRegisterPage';  // 인플루언서 회원가입 페이지
import MarketerRegisterPage from './pages/MarketerRegisterPage';  // 광고주 회원가입 페이지
import RegisterSelectPage from './pages/RegisterSelectPage';  // 가입 선택 페이지 (v5)
import IdPasswordFind from './pages/IdPasswordFind';  // 아이디/비밀번호 찾기 페이지
import InquiryPage from './pages/InquiryPage';  // 문의하기 페이지
import NoticePage from './pages/NoticePage';  // 공지사항 페이지
import InfluencerMybiz from './pages/influencerpages/InfluencerMybiz';  // 인플루언서 마이비즈 페이지
import MarketerMybiz from './pages/marketerpages/MarketerMybiz';  // 광고주 마이비즈 페이지
import InfluencerFreeContractPage from './pages/adminpages/InfluencerFreeContractPage'; // 어드민 인플루언서프리랜서 계약관리 페이지 
import InfluencerSNSUpdatePage from './pages/adminpages/InfluencerSNSUpdatePage'; // 어드민 인플루언서 SNS 갱신 관리 페이지
import InfluencerSNSAddPage from './pages/adminpages/InfluencerSNSAddPage'; // 어드민 인플루언서 SNS 등록 추가 관리 페이지
import InfluencerInquiryCheckPage from './pages/adminpages/InfluencerInquiryCheckPage'; // 어드민 인플루언서 문의하기 관리 페이지
import AdvertiserAdCallCheckPage from './pages/adminpages/AdvertiserAdCallCheckPage'; // 어드민 광고대행 문의하기 관리 페이지
import NoticeDetailPage from './pages/NoticeDetailPage'; // 공지사항 상세 페이지
import PointBankChargeCheckPage from './pages/adminpages/PointBankChargeCheckPage'; // 어드민 포인트 무통장 입금 대기 관리 페이지
import CPSSettlementPendingPage from './pages/adminpages/CPSSettlementPendingPage'; // 어드민 CPS 결산 미진행건 처리 페이지
import RejectedResultsPage from './pages/adminpages/RejectedResultsPage'; // 어드민 결과물 거절 건 처리 페이지
import ProjectCompletionPage from './pages/adminpages/ProjectCompletionPage'; // 어드민 프로젝트 완료 처리 페이지
import OngoingProjectPage from './pages/adminpages/OngoingProjectPage'; // 어드민 진행중인 프로젝트 보기 페이지
import CompletedProjectPage from './pages/adminpages/CompletedProjectPage'; // 어드민 완료된 프로젝트 보기 페이지
import TermsPage from './pages/TermsPage'; // 이용약관 페이지
import PrivacyPolicyPage from './pages/PrivacyPolicyPage'; // 개인정보 처리방침 페이지
import RefundPolicyPage from './pages/RefundPolicyPage'; // 환불 정책 페이지
import FaqPage from './pages/FaqPage'; // 자주 묻는 질문 페이지


const API_URL = process.env.REACT_APP_API_URL;

/** pathname 변경 시 맨 위로 (POP·쿼리·hash 변경 제외) */
function ScrollToTop() {
  const { pathname } = useLocation();
  const navigationType = useNavigationType();

  useEffect(() => {
    if (navigationType === 'POP') return;
    window.scrollTo(0, 0);
  }, [pathname, navigationType]);

  return null;
}

function App() {
  const [isAdminLoggedIn, setIsAdminLoggedIn] = useState(false);

  return (
    <Router>
      <AppRoutes isAdminLoggedIn={isAdminLoggedIn} setIsAdminLoggedIn={setIsAdminLoggedIn} />
    </Router>
  );
}


function AppRoutes({ isAdminLoggedIn, setIsAdminLoggedIn }) {
  const location = useLocation();

  // 모든 hook은 조건부 return 이전에 선언 (React Rules of Hooks)
  const [isMobile, setIsMobile] = useState(window.innerWidth < 1024);
  const [adminBooting, setAdminBooting] = useState(false);

  useVersionCheck();

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 1024);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const isAdminRoute = location.pathname.startsWith('/admin');

  useEffect(() => {
    if (!isAdminRoute) return;
    setAdminBooting(true);
    (async () => {
      try {
        const res = await fetch(`${API_URL}/api/admin/me`, { credentials: 'include' });
        const data = await res.json();
        setIsAdminLoggedIn(!!data.ok);
      } catch {
        setIsAdminLoggedIn(false);
      } finally {
        setAdminBooting(false);
      }
    })();
  }, [isAdminRoute, setIsAdminLoggedIn]);

  // ⚠️ 공개 라우트 추가 시 반드시 이 목록도 동기화할 것
  const MOBILE_ALLOWED_PATHS = [
    '/', '/register', '/influencer/register', '/marketer/register',
    '/lp/marketer', '/lp/influencer',
    '/account/recovery', '/terms', '/privacy-policy', '/refund-policy',
    '/faq', '/inquiry', '/guide',
    '/marketer/mybiz', // 마이비즈 리스킨+반응형 적용에 따라 모바일 오픈
    '/influencer/mybiz', // 인플루언서 마이비즈 리스킨+반응형 적용에 따라 모바일 오픈
  ];
  // 동적 세그먼트가 붙는 경로는 프리픽스로 허용 (예: /notice/:id — 비즈 홈 새 소식 진입)
  const MOBILE_ALLOWED_PREFIXES = ['/notice'];

  // '/'는 trailing slash 제거 시 빈 문자열이 되므로 폴백 필수
  const currentPath = location.pathname.replace(/\/+$/, '') || '/';
  const isMobileAllowed =
    MOBILE_ALLOWED_PATHS.includes(currentPath) ||
    MOBILE_ALLOWED_PREFIXES.some((p) => currentPath === p || currentPath.startsWith(`${p}/`));

  if (isMobile && !isMobileAllowed) return <MobileBlock />;

  const renderAdmin = (el) =>
    adminBooting ? null : (isAdminLoggedIn ? el : <AdminLogin onLogin={() => setIsAdminLoggedIn(true)} />);

  return (
    <>
      <ScrollToTop />
      {/* v2 전환 예고 팝업 — 어드민 제외, 가입 경로 보류는 컴포넌트 내부 처리 (10/10 배포 시 제거) */}
      {!isAdminRoute && <UpdateNoticePopup />}
      <Routes>
      {/* 랜딩 페이지 */}
      <Route path="/" element={<LandingPage />} />

      {/* 타깃별 전용 랜딩(LP) */}
      <Route path="/lp/marketer" element={<MarketerLandingPage />} />
      <Route path="/lp/influencer" element={<InfluencerLandingPage />} />

      {/* 문의하기 페이지 */}
      <Route path="/contact" element={<ContactPage />} />

      {/* 인플루언서 회원가입 페이지 */}
      <Route path="/influencer/register" element={<InfluencerRegisterPage />} />  
      
      {/* 광고주 회원가입 페이지 */}
      <Route path="/marketer/register" element={<MarketerRegisterPage />} />

      {/* 가입 선택 (v5) */}
      <Route path="/register" element={<RegisterSelectPage />} />
      
      {/* 어드민 로그인 페이지 */}
      <Route path="/admin" element={renderAdmin(<AdminMain onLogout={() => setIsAdminLoggedIn(false)} />)} />

      {/* 공지 만들기 페이지 경로 추가 */}
      <Route path="/admin/create-notice" element={renderAdmin(<NoticeCreate />)} />

      {/* 광고주 관리 페이지 (인증 필요) */}
      <Route path="/admin/advertiser" element={renderAdmin(<AdvertiserPage />)} />

      {/* 광고주 관리 -> 문의하기 관리 페이지 (인증 필요) */}
      <Route path="/admin/advertiser/inquiry-check" element={renderAdmin(<AdvertiserInquiryCheckPage />)} />

      {/* 광고주 관리 -> 광고대행 문의하기 관리 페이지 (인증 필요) */}
      <Route path="/admin/advertiser/adcall-check" element={renderAdmin(<AdvertiserAdCallCheckPage />)} />

      {/* 인플루언서 관리 페이지 (인증 필요) */}
      <Route path="/admin/influencer" element={renderAdmin(<InfluencerPage />)} />
      
      {/* 인플루언서 관리 -> 가입승인 페이지 (인증 필요) */}
      <Route path="/admin/influencer/register-check" element={renderAdmin(<InfluencerRegisterCheckPage />)} />

      {/* 인플루언서 관리 -> 프리랜서 계약관리 페이지 (인증 필요) */}
      <Route path="/admin/influencer/free-contract" element={renderAdmin(<InfluencerFreeContractPage />)} />

      {/* 인플루언서 관리 -> SNS 갱신 관리 페이지 (인증 필요) */}
      <Route path="/admin/influencer/sns-update" element={renderAdmin(<InfluencerSNSUpdatePage />)} />

      {/* 인플루언서 관리 -> SNS 등록 추가 관리 페이지 (인증 필요) */}
      <Route path="/admin/influencer/sns-add" element={renderAdmin(<InfluencerSNSAddPage />)} />

      {/* 인플루언서 관리 -> 문의하기 관리 페이지 (인증 필요) */}
      <Route path="/admin/influencer/inquiry-check" element={renderAdmin(<InfluencerInquiryCheckPage />)} />

      {/* 포인트 관리 페이지 (인증 필요) */}
      <Route path="/admin/point" element={renderAdmin(<PointPage />)} />

      {/* 포인트 관리 -> 무통장 입금 대기 관리 페이지 (인증 필요) */}
      <Route path="/admin/point/bank-charge/check" element={renderAdmin(<PointBankChargeCheckPage />)} />

      {/* 프로젝트 관리 페이지 (인증 필요) */}
      <Route path="/admin/project" element={renderAdmin(<ProjectPage />)} />

      {/* 프로젝트 관리 -> 구매당 리워드 결산 미진행건 처리 페이지 (인증 필요) */}
      <Route path="/admin/project/cps-settlement-pending" element={renderAdmin(<CPSSettlementPendingPage />)} />

      {/* 프로젝트 관리 -> 결과물 거절 건 처리 페이지 (인증 필요) */}
      <Route path="/admin/project/rejected-results" element={renderAdmin(<RejectedResultsPage />)} />

      {/* 프로젝트 관리 -> 프로젝트 완료 처리 페이지 (인증 필요) */}
      <Route path="/admin/project/completion" element={renderAdmin(<ProjectCompletionPage />)} />

      {/* 프로젝트 관리 -> 진행중인 프로젝트 보기 페이지 (인증 필요) */}
      <Route path="/admin/project/ongoing" element={renderAdmin(<OngoingProjectPage />)} />
      <Route path="/admin/project/completed" element={renderAdmin(<CompletedProjectPage />)} />

      {/* 매출 관리 페이지 (인증 필요) */}
      <Route path="/admin/money" element={renderAdmin(<MoneyPage />)} />

      {/* 광고주 관리 -> 환불 관리 페이지 (인증 필요) */}
      <Route path="/admin/advertiser/refund" element={renderAdmin(<AdvertiserRefundPage />)} />

      {/* 인플루언서 관리 -> 환전 관리 페이지 (인증 필요) */}
      <Route path="/admin/influencer/exchange" element={renderAdmin(<InfluencerExchangePage />)} />

      {/* 인플루언서 관리 -> 인플루언서 정보관리 페이지 (인증 필요) */}
      <Route path="/admin/influencer/info-management" element={renderAdmin(<InfluencerInfoPage />)} />

      {/* 광고주 관리 -> 광고주 정보 관리 페이지 (인증 필요) */}
      <Route path="/admin/advertiser/info-management" element={renderAdmin(<AdvertiserInfoPage />)} />

      {/* 인플루언서 마이비즈 페이지 (구 /influencer/home은 폐지 — 활동 홈이 흡수, 구 URL은 catch-all로 랜딩 경유 복귀) */}
      <Route path="/influencer/mybiz" element={<InfluencerMybiz />} />

      {/* 광고주 메인 페이지 */}

      {/* 광고주 마이비즈 페이지 */}
      <Route path="/marketer/mybiz" element={<MarketerMybiz />} />

      {/* 아이디/비밀번호 찾기 페이지 */}
      <Route path="/account/recovery" element={<IdPasswordFind />} />

      {/* 서비스 가이드 페이지 */}
      <Route path="/guide" element={<ServiceGuide />} />

      {/* 문의하기 페이지 */}
      <Route path="/inquiry" element={<InquiryPage />} />

      {/* 자주 묻는 질문 페이지 */}
      <Route path="/faq" element={<FaqPage />} />

      {/* 공지사항 페이지 */}
      <Route path="/notice" element={<NoticePage />} />

      {/* 공지사항 상세 페이지 */}
      <Route path="/notice/:id" element={<NoticeDetailPage />} />

      {/* 약관 페이지 */}
      <Route path="/terms" element={<TermsPage />} />
      <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
      <Route path="/refund-policy" element={<RefundPolicyPage />} />


      {/* 미매칭 경로(구 /marketer/home 포함) → 랜딩으로. 로그인 상태면 랜딩이 역할별 마이비즈로 보냄 */}
      <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </>
  );
}

export default App;
